import { useTranslation as useI18nTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { setLanguage } from '@/core/store/slices/ui'

export const useTranslation = (namespace: string = 'common') => {
	const { t, i18n } = useI18nTranslation(namespace)
	const dispatch = useDispatch()

	const changeLanguage = (language: string) => {
		i18n.changeLanguage(language)
		dispatch(setLanguage(language))
	}

	const getTranslation = (
		translations: Record<string, string>,
		lang: string,
		defaultValue: string = ''
	) => {
		const baseLanguage = lang?.split('-')[0]
		if (baseLanguage === 'es') {
			return (
				translations['es-ES'] ||
				translations['es-419'] ||
				translations['en-US'] ||
				translations['en'] ||
				defaultValue
			)
		} else if (baseLanguage === 'en') {
			return translations['en-US'] || translations['en'] || defaultValue
		}

		return translations[lang] || translations['en-US'] || defaultValue
	}

	return {
		t,
		changeLanguage,
		getTranslation,
		currentLanguage: i18n.language,
		i18n,
	}
}

export default useTranslation
